module.exports = __webpack_public_path__ + "static/img/16-1.8438d752.jpg";